export const SEO_DEFAULTS = {
  siteName: "LocalLive",
  baseTitle: "High School Sports Streaming",
  baseDescription:
    "Watch live high school sports streams from schools across the United States. Find your school and watch games, matches, and events online.",
  baseKeywords:
    "high school sports, live streaming, school sports, athletics, games, online streaming",
  author: "SportsEngine",
  twitterHandle: "@SportsEngine",
  defaultImage: "/logo192.png",
  baseUrl: process.env.REACT_APP_BASE_URL || "https://locallive.tv",
} as const;

export const generateSchoolSEO = (school: {
  schoolName: string;
  city: string;
  state: string;
  conference?: string | null;
  logoUrl?: string | null;
}) => ({
  title: `${school.schoolName} - Live Sports Streaming`,
  description: `Watch live sports from ${school.schoolName} in ${school.city}, ${school.state}. Stream games, matches, and events online with LocalLive.`,
  keywords: `${school.schoolName}, ${school.city}, ${school.state}, high school sports, live streaming, ${school.conference || "athletics"}, LocalLive`,
  image: school.logoUrl || SEO_DEFAULTS.defaultImage,
});
